import * as React from "react";

function BuyButtonComponent() {
  // Paste the stripe-buy-button snippet in your React component
  return (
    <stripe-buy-button
      // buy-button-id=""
      buy-button-id="buy_btn_1NC5KdKK7HItAOBSb5LRyzJZ"
      publishable-key="pk_test_51N8mQTKK7HItAOBSoHWoChcqP53hzfnbFet65eQ3s7Bb7EDnqzmul6ZC5lieIcgdKNGtNAQsZ1LlxIAMtnxvrnm900dxmTPmsF"
    ></stripe-buy-button>
  );
}

export default BuyButtonComponent;

// !COMPACT
// buy-button-id="buy_btn_1NC7CYKK7HItAOBSSAW4tv42"
// !STANDARD
// buy-button-id="buy_btn_1NC5KdKK7HItAOBSb5LRyzJZ"
// !LARGE
// buy-button-id="buy_btn_1NC7LwKK7HItAOBSRdz4BXPm"
